import { useCallback, useState } from "react";

/**
 * Focus state for InputDateField. The label shrinks while the field is focused or holds a
 * date — the same floating-label behaviour as DefaultInputField.
 */
export const useInputDateField = () => {
  const [isFocused, setIsFocused] = useState(false);

  const onFocus = useCallback(() => setIsFocused(true), []);
  const onBlur = useCallback(() => setIsFocused(false), []);

  return { isFocused, onFocus, onBlur };
};
